import { createEvent } from 'effector';

import { PartnersManagementState } from './PartnersManagementState';

export const partnersManagementEvent =
  createEvent<Partial<PartnersManagementState>>('partnersManagement');
